import { ChatMessage } from '@ant-design/pro-chat';
import {
  ContentObjectForReasoning,
  ReasoningToolCallStatus,
} from '../../../interfaces/copilotChat';
import classNames from 'classnames';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { calcTimeDiff } from '../../../utils/timeUtils';

interface ReasoningMessageProps {
  className?: string;
  message: ChatMessage;
  result: ContentObjectForReasoning;
}

const _calcExecutionTime = (time1: string | null, time2: string | null) => {
  return calcTimeDiff(time1, time2, 'seconds');
};

const ENABLED_REASONING_EXECUTION_TIME =
  process.env.NODE_ENV !== 'production' ||
  !['https://api2.cirra.ai', 'https://api.cirra.ai'].includes(
    process.env.REACT_APP_API_BASE_URL || ''
  );

const ReasoningMessage: React.FC<ReasoningMessageProps> = ({
  className,
  result,
}) => {
  const toolCall = result.tool_call;
  let statusIcon;
  let executionTimeSecs;
  if (toolCall.status === ReasoningToolCallStatus.IN_PROGRESS) {
    statusIcon = <LoadingOutlined />;
  } else if (toolCall.status === ReasoningToolCallStatus.SUCCESS) {
    statusIcon = <CheckCircleOutlined />;
    executionTimeSecs = _calcExecutionTime(
      toolCall.completed_at,
      toolCall.started_at
    );
  } else if (toolCall.status === ReasoningToolCallStatus.FAILED) {
    statusIcon = <CloseCircleOutlined />;
    executionTimeSecs = _calcExecutionTime(
      toolCall.failed_at,
      toolCall.started_at
    );
  }

  return (
    <div className={classNames('reasoning-message', className)}>
      <div className="row">
        <div className="col-icon">{statusIcon}</div>
        <div className="col-main">
          {result.title}
          {ENABLED_REASONING_EXECUTION_TIME &&
            executionTimeSecs &&
            ` (${executionTimeSecs}s)`}
        </div>
      </div>
      <div className="row">
        <div className="col-icon"></div>
        <div className="col-main reasoning-message-error">
          {toolCall.status !== ReasoningToolCallStatus.IN_PROGRESS &&
            toolCall.error &&
            (toolCall.error.message as string)}
        </div>
      </div>
    </div>
  );
};

export default ReasoningMessage;
